import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { Phone } from 'lucide-react';
import { ShortlistedProfile } from '../../../../api/DTO/ShortlistedProfile';
import { useProfileContactInfo } from '../../../../api/useProfileContactInfo';
import { useAiSearchProfilePopoutContext } from '../../../AiSearchProfilePopout/AiSearchProfilePopoutContext';
import LinkedInCompanyIcon from '@/Components/TalentMeshIcons/LinkedInCompanyIcon';
import WindowsMailIcon from '@/Components/TalentMeshIcons/WindowsMailIcon';

type ContactInfoCellProps = ShortlistedProfile & {
    onMailClick?: 'disabled' | (() => void);
};

const ContactInfoCell = ({ onMailClick, ...profileResponse }: ContactInfoCellProps) => {
    const { id, profile, searchCriteriaScores, emailSentCount } = profileResponse;
    const { openProfilePopout } = useAiSearchProfilePopoutContext();
    const { data, isLoading } = useProfileContactInfo(profile.url);

    const handleIconClick = () => {
        openProfilePopout({
            id,
            education: profile.education,
            experience: profile.experience,
            location: profile.location,
            name: profile.name,
            about: profile.about,
            url: profile.url,
            searchCriteriaScores,
            languages: profile.languages,
            emailSentCount,
        });
    };

    return (
        <div className="flex max-h-6 w-full items-center gap-0.25">
            <Button asChild variant="ghost" size="icon-fit">
                <a className="scale-125" href={profile.url} target="_blank" rel="noreferrer">
                    <LinkedInCompanyIcon />
                </a>
            </Button>
            {isLoading ? (
                <Spinner className="text-primary h-4 w-4 grow" />
            ) : (
                <>
                    {data?.personalEmailAvailable && (
                        <Button
                            variant="ghost"
                            size="icon-fit"
                            data-cy="contactInfoEmail"
                            onClick={onMailClick === 'disabled' ? undefined : onMailClick || handleIconClick}
                        >
                            <div className="-mb-0.25 scale-125">
                                <WindowsMailIcon />
                            </div>
                        </Button>
                    )}
                    {data?.phoneNumberAvailable && (
                        <Button variant="ghost" size="icon-fit" data-cy="contactInfoPhone" onClick={handleIconClick}>
                            <Phone className="fill-foreground size-4.5" />
                        </Button>
                    )}
                </>
            )}
        </div>
    );
};

export default ContactInfoCell;
